/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';

export const LockedLinkChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(
	({size = 256, className, ...props}, ref) => (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden={true}
			{...props}
		>
			<path
				fill="currentColor"
				d="M105.37 76.0012c7.699 0 15.323 1.517 22.436 4.4639 3.578 1.4822 6.992 3.3109 10.194 5.456v37.0729c-1.712-4.814-4.482-9.202-8.126-12.83-.007-.006-.014-.013-.021-.019-3.215-3.216-7.031-5.768-11.232-7.508s-8.704-2.636-13.251-2.636-9.0504.896-13.2512 2.636c-4.2007 1.74-8.0177 4.292-11.2324 7.508l-34.7422 34.742c-6.4874 6.487-10.1362 15.283-10.1446 24.457-.0082 9.174 3.6237 17.976 10.0987 24.475 3.2138 3.224 7.0325 5.783 11.2363 7.53s8.7113 2.649 13.2637 2.652c4.5524.004 9.062-.891 13.2685-2.632 4.2063-1.74 8.0284-4.294 11.2471-7.513l5.1101-5.111c4.687-4.686 12.285-4.686 16.971 0 4.686 4.687 4.686 12.285 0 16.971l-5.109 5.109c-5.45 5.451-11.921 9.773-19.0424 12.72-7.1218 2.947-14.7555 4.462-22.4629 4.456-7.7076-.006-15.3387-1.532-22.4561-4.49s-13.582-7.29-19.0234-12.749l-.001-.001c-10.964-11.002-17.1145-25.906-17.1006-41.439.0142-15.532 6.1918-30.425 17.1758-41.408l34.7393-34.739c5.4432-5.4444 11.9061-9.7632 19.0185-12.7099 7.1131-2.9469 14.7372-4.4638 22.4368-4.4639"
			/>
			<path
				fill="currentColor"
				d="M102.496 120.314c6.454-1.505 12.906 2.508 14.411 8.963 1.413 6.063 4.443 11.627 8.761 16.102l.421.43.009.01c3.214 3.224 7.033 5.783 11.237 7.53 4.203 1.747 8.711 2.649 13.263 2.652 4.553.004 9.062-.891 13.269-2.632 4.206-1.74 8.028-4.294 11.247-7.513L183.97 137h33.941l-25.825 25.825c-5.45 5.451-11.921 9.773-19.042 12.72-7.122 2.947-14.756 4.462-22.463 4.456-7.708-.006-15.339-1.532-22.456-4.49-7.118-2.958-13.582-7.29-19.024-12.749-7.701-7.712-13.0939-17.423-15.5682-28.037-1.5045-6.454 2.5088-12.907 8.9632-14.411M234.25 50.25h-12.5v-9.375c0-4.9728-1.975-9.7419-5.492-13.2583-3.516-3.5163-8.285-5.4917-13.258-5.4917s-9.742 1.9754-13.258 5.4917c-3.517 3.5164-5.492 8.2855-5.492 13.2583v9.375h-12.5c-1.658 0-3.247.6585-4.419 1.8306-1.173 1.1721-1.831 2.7618-1.831 4.4194v43.75c0 1.658.658 3.247 1.831 4.419 1.172 1.173 2.761 1.831 4.419 1.831h62.5c1.658 0 3.247-.658 4.419-1.831 1.173-1.172 1.831-2.761 1.831-4.419V56.5c0-1.6576-.658-3.2473-1.831-4.4194-1.172-1.1721-2.761-1.8306-4.419-1.8306M203 83.0625c-.927 0-1.833-.2749-2.604-.79s-1.372-1.2471-1.727-2.1037c-.354-.8565-.447-1.799-.266-2.7083.18-.9093.627-1.7445 1.282-2.4001.656-.6555 1.491-1.102 2.401-1.2828.909-.1809 1.851-.0881 2.708.2667.856.3548 1.588.9556 2.104 1.7265.515.7708.79 1.6771.79 2.6042 0 1.2432-.494 2.4355-1.373 3.3146-.88.879-2.072 1.3729-3.315 1.3729M215.5 50.25h-25v-9.375c0-3.3152 1.317-6.4946 3.661-8.8388s5.524-3.6612 8.839-3.6612 6.495 1.317 8.839 3.6612 3.661 5.5236 3.661 8.8388z"
			/>
		</svg>
	),
);
